/**
 * Utility de logging condicional para optimización de performance
 * Solo muestra logs en desarrollo, elimina logs en producción
 */

export const isDev = process.env.NODE_ENV === 'development';

// Logging condicional - solo en desarrollo
export const log = isDev ? console.log.bind(console) : () => {};
export const warn = isDev ? console.warn.bind(console) : () => {};
export const info = isDev ? console.info.bind(console) : () => {};

// Errores siempre se muestran (críticos para debugging)
export const error = console.error.bind(console);

// Logger con prefijos para mejor organización
export const createLogger = (module) => ({
  log: isDev ? (...args) => console.log(`[${module}]`, ...args) : () => {},
  warn: isDev ? (...args) => console.warn(`[${module}]`, ...args) : () => {},
  info: isDev ? (...args) => console.info(`[${module}]`, ...args) : () => {},
  error: (...args) => console.error(`[${module}]`, ...args)
});

// Exportar logger por defecto
export const logger = createLogger('App');